<template>
  <div class="PrintPosTkFcf">
    <div style="padding: 9px;">
      <div
        v-if="dataProps.data.header.FeMhEstado == 'RECHAZADO'"
        style="width: 100%; background-color: red"
      >
        <h3 style="color: white; text-align: center">
          DOCUMENTO RECHAZADO POR HACIENDA
        </h3>
      </div>
      <div
        v-if="dataProps.data.header.FeMhEstado == 'INVALIDADO'"
        style="width: 100%; background-color: red"
      >
        <h3 style="color: white; text-align: center">
          DOCUMENTO INVALIDADO POR HACIENDA
        </h3>
      </div>
      <table 
        :style="tableStyle"
      >
        <tr>
          <td
            style="
              font-size: 14pt;
              text-align: center;
              vertical-align: middle;
              width: 100%;
            "
          >
            <b>{{
              dataProps.data.user.business != undefined ||
              dataProps.data.user.business != null
                ? dataProps.data.user.business.toUpperCase()
                : ""
            }}</b>
          </td>
        </tr>
        <tr>
          <td
            style="
              color: white;
              text-align: center;
              vertical-align: middle;
              width: 100%;
            "
          >
            <img
              v-if="dataProps.data.branch?.BranchLogoPath != null && dataProps.data.branch?.BranchLogoPath != '' && dataProps.data.branch?.BranchLogoPath != 'null'"
              style="max-width: 200px; height: 50px"
              :src="dataProps.data.branch.BranchLogoPath"
              
            />
          </td>
        </tr>

        <tr v-if="!isBranchBilledInfo">
          <td
            style="
              text-align: center;
              vertical-align: middle;
              width: 100%;
            "
          >
            RAZÓN SOCIAL:
            {{
              dataProps.data.branch.BusinessBillingName !=
                undefined ||
              dataProps.data.branch.BusinessBillingName != null
                ? dataProps.data.branch.BusinessBillingName.toUpperCase()
                : ""
            }}
          </td>
        </tr>
        
        <tr v-if="!isBranchBilledInfo">
          <td
            style="
              text-align: center;
              vertical-align: middle;
              width: 100%;
            "
          >
            ACTIVIDAD:
            {{
              dataProps.data.header.EmisorDescActividad !=
                undefined ||
              dataProps.data.header.EmisorDescActividad != null
                ? dataProps.data.header.EmisorDescActividad.toUpperCase()
                : ""
            }}
          </td>
        </tr>
        
        <tr v-if="!isBranchBilledInfo 
            && dataProps.data.branch.BranchLegalAddress 
            && !dataProps.data.branch.BranchLegalAddress.startsWith('---')">
          <td
            style="
              vertical-align: middle;
              width: 100%;
            "
          >
            DIRECCIÓN:
            {{
              dataProps.data.branch.BranchLegalAddress != undefined ||
              dataProps.data.branch.BranchLegalAddress != null
                ? dataProps.data.branch.BranchLegalAddress.toUpperCase()
                : ""
            }}
          </td>
        </tr>
        
        <tr v-if="!isBranchBilledInfo && 
                  (dataProps.data.branch.BranchPhone 
                  || dataProps.data.branch.BranchMobile 
                  || dataProps.data.branch.BranchManagerMobile 
                  || dataProps.data.branch.BranchContactMobile)">
          <td
            style="
              vertical-align: middle;
              width: 100%;
            "
          >
            <span v-if="dataProps.data.branch.BranchPhone 
              && (!dataProps.data.branch.BranchPhone.startsWith('00') && !dataProps.data.branch.BranchPhone.startsWith('--'))">
              TÉLEFONO:
              {{
                  dataProps.data.branch.BranchPhone.toUpperCase()
              }}
            </span>
            
            <span v-if="(dataProps.data.branch.BranchMobile && !dataProps.data.branch.BranchMobile.startsWith('00'))||
              (dataProps.data.branch.BranchManagerMobile && !dataProps.data.branch.BranchManagerMobile.startsWith('00')) ||
              (dataProps.data.branch.BranchContactMobile && !dataProps.data.branch.BranchContactMobile.startsWith('00'))">
            WHATSAPP:
            {{
              dataProps.data.branch.BranchMobile ||
              dataProps.data.branch.BranchManagerMobile ||
              dataProps.data.branch.BranchContactMobile
            }}
            </span>
          </td>
        </tr>
        <tr v-if="!isBranchBilledInfo">
          <td
            style="
              vertical-align: middle;
              width: 100%;
            "
          >
            E-MAIL: {{ dataProps.data.branch.BranchEmail }}
          </td>
        </tr>
        <tr v-if="!isBranchBilledInfo">
          <td
            style="
              vertical-align: middle;
              width: 100%;
            "
          >
            NIT: {{ BillingNit }}
          </td>
        </tr>
        <tr v-if="!isBranchBilledInfo">
          <td
            style="
              vertical-align: middle;
              width: 100%;
            "
          >
            NRC: {{ BillingNrc }}
          </td>
        </tr>
        <tr v-if="isBranchBilledInfo">
           <td style="
              vertical-align: middle;
              width: 100%; 
              text-align: center;"
              v-html="modifiedBranchBilledInfo()"></td>
        </tr>
      </table>
      <hr/>
      <table 
        :style="tableStyle"
      >
        <tr>
          <td>
            <b>Cliente:</b>
            {{
              dataProps.data.header.InvoiceName != undefined ||
              dataProps.data.header.InvoiceName != null
                ? dataProps.data.header.InvoiceName.toUpperCase()
                : ""
            }}
          </td>
        </tr>
        <tr v-if="dataProps.data.header.InvoiceAddress && dataProps.data.header.InvoiceAddress !== ''">
          <td>
            <b>Direccion:</b>
            {{
              dataProps.data.header.InvoiceAddress != undefined ||
              dataProps.data.header.InvoiceAddress != null
                ? dataProps.data.header.InvoiceAddress.toUpperCase()
                : ""
            }}
          </td>
        </tr>
        <tr v-if="dataProps.data.header.InvoiceNIT">
          <td>
            <b>NIT:</b>
            {{ dataProps.data.header.InvoiceNIT || "---" }}
          </td>
        </tr>
        <tr v-if="dataProps.data.header.InvoiceDUI">
          <td>
            <b>DUI:</b>
            {{ dataProps.data.header.InvoiceDUI || "---" }}
          </td>
        </tr>
        <tr v-if="dataProps.data.header.InvoiceEntity">
          <td><b>Actividad economica:</b> {{ dataProps.data.header.InvoiceEntity }}</td>
        </tr>
      </table><hr/>
      <table  
        :style="tableStyle"
        >
        <tr>
          <td style="width: 25%;">Cant.</td>
          <td style="width: 25%;">P.<br/>Unit.</td>
          <td style="width: 25%;">Desc.<br/>Por Item</td>
          <td style="width: 25%;">SubTotal</td>
        </tr>
      </table>
      <table 
        :style="tableStyle"
      >
        <!-- Itera sobre cada item en dataProps.data.body -->
        <tr v-for="(item, index) in dataProps.data.body" :key="index">
          <hr/>
          <table :style="tableStyle">
          <tr>
            <td colspan="4">
              {{ item.ItemDescription + " " + (parseFloat(item.ItemGravada) > 0 ? "(G)" : "") + (parseFloat(item.ItemExenta) > 0 ? "(E)" : "") + (parseFloat(item.ItemNoSuj) > 0 ? "(NS)" : "") + (parseFloat(item.ItemNoGravada) > 0 ? "(NG)" : "") }}
            </td>
          </tr>
          <tr>
            <td style="width: 25%; text-align: center;">
              {{ item.ItemQuantity }}
            </td>

            <td style="width: 25%; text-align: right;">
              {{dataProps.data.header.InvoiceCurrency}}
              {{
                (item.ItemNoGravada > 0) ? 0 : numberWithCommas(parseFloat(item.ItemUnitPrice))
              }}
            </td>
            <td style="width: 25%; text-align: right;">
              {{dataProps.data.header.InvoiceCurrency}}
              {{numberWithCommas(
                  parseFloat(item.ItemDiscount)
                )
              }}
            </td>
            <td style="width: 25%; text-align: right;">
              {{dataProps.data.header.InvoiceCurrency}}
              {{parseFloat(item.ItemGravada) > 0 ? numberWithCommas(parseFloat(item.ItemGravada)) : ""}}
              {{parseFloat(item.ItemExenta) > 0 ? numberWithCommas(parseFloat(item.ItemExenta)) : ""}}
              {{parseFloat(item.ItemNoSuj) > 0 ? numberWithCommas(parseFloat(item.ItemNoSuj)) : ""}}
              {{parseFloat(item.ItemNoGravada) > 0 ? numberWithCommas(parseFloat(item.ItemNoGravada)) : ""}}
            </td>
          </tr>
          </table>
        </tr>
        
      </table>
      <hr />
      <table 
        :style="tableStyle"
      >
        <tr v-if="parseFloat(dataProps.data.header.InvoiceTotalNoSuj)">
          <td style=" width: 75%">
            Suma No Sujeta:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceTotalNoSuj
                )
              )
            }}
          </td>
        </tr>
        <tr v-if="parseFloat(dataProps.data.header.InvoiceTotalExenta)">
          <td style=" width: 75%">
            Suma Exento:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceTotalExenta
                )
              )
            }}
          </td>
        </tr>
        <tr v-if="parseFloat(dataProps.data.header.InvoiceTotalGravada)">
          <td style=" width: 75%">
            Suma Gravado:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceTotalGravada
                )
              )
            }}
          </td>
        </tr>
      </table>
      <hr/>
      <table 
        :style="tableStyle"
      >
        <tr>
          <td style=" width: 75%">
            Suma Total de Operaciones:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceSubTotal
                )
              )
            }}
          </td>
        </tr>
        <tr v-if="parseFloat(dataProps.data.header.InvoiceDescuNoSuj)">
          <td style=" width: 75%">
            Monto global Desc., Rebajas y otros a vtas. no sujetas:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceDescuNoSuj
                )
              )
            }}
          </td>
        </tr>
        <tr v-if="parseFloat(dataProps.data.header.InvoiceDescuExenta)">
          <td style=" width: 75%">
            Monto global Desc., Rebajas y otros a vtas. Exentas:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceDescuExenta
                )
              )
            }}
          </td>
        </tr>
        <tr v-if="parseFloat(dataProps.data.header.InvoiceDescuGravada)">
          <td style=" width: 75%">
            Monto global Desc., Rebajas y otros a vtas. gravadas:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceDescuGravada
                )
              )
            }}
          </td>
        </tr>
        <tr>
          <td style=" width: 75%">
            Sub-Total:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceSubTotal
                )
              )
            }}
          </td>
        </tr>
        <tr v-if="parseFloat(dataProps.data.header.InvoiceIvaRete1)">
          <td style=" width: 75%">
            IVA Retenido (1%):
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceIvaRete1
                )
              )
            }}
          </td>
        </tr>
        <tr v-if="parseFloat(dataProps.data.header.InvoiceIvaPerce1)">
          <td style=" width: 75%">
            IVA Percibido (1%):
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceIvaPerce1
                )
              )
            }}
          </td>
        </tr>
        <tr v-if="parseFloat(dataProps.data.header.InvoiceReteRenta)">
          <td style=" width: 75%">
            Retencion Renta:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceReteRenta
                )
              )
            }}
          </td>
        </tr>
        <tr v-if="parseFloat(dataProps.data.header.InvoiceTotalNoGravado)">
          <td style=" width: 75%">
            Total otros montos no afectos:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceTotalNoGravado
                )
              )
            }}
          </td>
        </tr>
        <tr>
          <td style=" width: 75%">
            Total a Pagar:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }}{{
              numberWithCommas(
                parseFloat(
                  dataProps.data.header.InvoiceTotalPagar
                )
              )
            }}
          </td>
        </tr>
        <tr>
          <td style=" width: 75%">
            Condicion de Pago:
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceStatusDescription }}
          </td>
        </tr>
        <tr>
          <td style=" width: 75%">
            Efectivo
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }} {{cash}}
          </td>
        </tr>
        <tr>
          <td style=" width: 75%">
            Cambio
          </td>
          <td style=" width: 25%; text-align: right;">
            {{ dataProps.data.header.InvoiceCurrency
            }} {{change}}
          </td>
        </tr>
      </table>
      <hr/>
      <table :style="tableStyle">
        <tr>
          <td style="text-transform: uppercase;">Valor en Letras: {{ dataProps.data.header.InvoiceTotalLetras }}</td>
        </tr>
      </table>
      <hr/>
      <table  style="
        font-size: 10pt;
        border-collapse: collapse;
        width: 100%;
        vertical-align: top;
      ">
        <tr>
          <td style="text-align: center;">
            {{ 
              dataProps.data.header.InvoiceTotalNoGravado > 0 
              ? '(G)- GRAVADO (E)- EXENTO (NS)- NO SUJETO (NG)- OTROS MONTOS NO AFECTOS' 
              : '(G)- GRAVADO (E)- EXENTO (NS)- NO SUJETO' 
            }}  
          </td>
        </tr>
      </table>
      <br/>
      <table  :style="tableStyle">
      <tr>
          <td
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
              font-size: 10pt;
            "
            colspan="2"
          >
            SELLO RECEPCIÓN:
            <b>{{ dataProps.data.header.SelloRecepcion }}</b>
          </td>
        </tr>
      <tr>
        <td style="width: 50%; vertical-align: top;">
          <table style="width: 100%; border-collapse: collapse;">
            <tr>
          <td
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
              font-size: 10pt;
            "
          >
            COD. GENERACIÓN:
          </td>
        </tr>
        <tr>
          <td style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
              font-size: 10pt;
            ">
            <b>{{ dataProps.data.header.CodigoGeneracion }}</b>
          </td>
        </tr>
        <tr>
          <td
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
              font-size: 10pt;
            "
          >
            NUM. CONTROL:

          </td>
        </tr>
        <tr>
          <td style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
              font-size: 10pt;
            "><b style="font-size: 10pt;">{{ dataProps.data.header.NumeroControl }}</b></td>
        </tr>
        <tr>
          <td
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
              font-size: 10pt;
            "
          >
            CORRELATIVO FACTURA:
            
          </td>
        </tr>
        <tr>
          <td style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
              font-size: 10pt;
            "><b style="font-size: 10pt;">{{ dataProps.data.header.ID_Invoice }}</b></td>
        </tr>
        <tr>
          <td
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
              font-size: 10pt;
            "
          >
            MÓDELO DE FACTURACIÓN:
            <b>{{
              dataProps.data.dteJson.IdentificacionTipoModelo == 1
                ? "Previo"
                : ""
            }}
            {{
              dataProps.data.dteJson.IdentificacionTipoModelo == 2
                ? "Diferido"
                : ""
            }}</b>
          </td>
        </tr>
        <tr>
            <td
              style="
                text-align: left;
                vertical-align: middle;
                width: 100%;
                font-size: 10pt;
              "
            >
              TIPO DE TRANSMISIÓN:
              <b>{{
                dataProps.data.dteJson.IdentificacionTipoOperacion == 1
                  ? "Normal"
                  : ""
              }}
              {{
                dataProps.data.dteJson.IdentificacionTipoOperacion == 2
                  ? "Por contingencía"
                  : ""
              }}</b>
            </td>
          </tr>
          <tr>
            <td
              style="
                text-align: left;
                vertical-align: middle;
                width: 100%;
                font-size: 10pt;
              "
            >
              FECHA DE EMISIÓN:
              <b>{{ dataProps.data.header.InvoiceDate }}</b>
            </td>
          </tr>
          <tr>
            <td
              style="
                text-align: left;
                vertical-align: middle;
                width: 100%;
                font-size: 10pt;
              "
            >
              HORA DE EMISIÓN:
              <b>{{ dataProps.data.header.IdentificacionHorEmi }}</b>
            </td>
          </tr>
          </table>
        </td>

        <td style="width: 50%; text-align: center; vertical-align: top;"> 
           <img
              ref="qrcode"
              :src="urlQr"
              style="height: 200px"
            />
          </td>
        </tr>
        <tr v-if="dataProps.data.header.InvoiceInternalNote && dataProps.data.header.InvoiceInternalNote.length > 0">
          <td
            style="
              text-align: left;
              vertical-align: middle;
              width: 100%;
              font-size: 10pt;
            "
          >
            OBSERVACIONES:
            <b>{{ stripHTML(dataProps.data.header.InvoiceInternalNote) }}</b>
          </td>
        </tr>
        <template 
          v-if="dataProps.data.header.ShowResponsabilitiesInInvoice || dataProps.data.header.InvoiceTotalPagar >= 25000"
          >
          <tr>
            <td><b>Responsable por parte del receptor: </b> {{ dataProps.data.header.InvoiceExtNombEntrega }}</td>
          </tr>
          <tr>
            <td><b>No. Documento: </b> {{ dataProps.data.header.InvoiceExtDocuEntrega }}</td>
          </tr>
          <tr>
            <td><b>Responsable por parte del emisor: </b> {{ dataProps.data.header.InvoiceExtNombRecibe }}</td>
          </tr>
          <tr>
            <td><b>No. Documento: </b> {{ dataProps.data.header.InvoiceExtDocuRecibe }}</td>
          </tr>
        </template>
      </table>

      <table 
        :style="tableStyle"
      >
        <tr>
          <td style="padding-top: 8px;">
            <GuaranteePrintBlock
              :html="dataProps.guaranteeHtml"
              :business-id="dataProps.businessId"
              :branch-id="dataProps.branchId"
              guarantee-type="TICKET"
              font-size="9pt"
            />
          </td>
        </tr>
        <tr>
          <td style="text-align: center">¡Gracias por su visitaAA!</td>
        </tr>
        <!-- espacio en blanco al finalizar factura de ticket -->
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td style="border-width: 2px; text-overflow: ellipsis; overflow: hidden;">
            <div  
              style=" width: 100%; text-align: center; text-wrap: nowrap; text-overflow: ellipsis; overflow: hidden;"
            >
              ------------------------------------------------------------------------------------------------------
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
import { addFormatToNIT, addFormatNRC } from "../../helpers/misc";
import { formatNumber } from "../../helpers/money";
import GuaranteePrintBlock from "@/components/ReportsAndPrintings/GuaranteePrintBlock.vue";

export default {
  name: "PrintPosTkFcf99Store",
  model: {
    event: "input",
    prop: "type",
  },
  props: {
    dataProps: {
      type: Object,
    },
    hideQr: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
  },
  components: {
    GuaranteePrintBlock,
  },
  data() {
    return {
      header: null,
      footer: null,
      loading: false,
      numPages: 0,
      mailLabel: null,
      valuesRows: [],
      urlQr: null,
      typePrint: 0,
      keyMaster: JSON.parse(localStorage.getItem("user")).keymaster,
      ticketformat3nstar: JSON.parse(localStorage.getItem("user")).ticketformat3nstar || 0,
      cash: 0,
      change: 0,
      tableStyle: {
        fontSize: '10pt',
        borderCollapse: 'collapse',
        width: '100%',
        verticalAlign: 'top',
        fontWeight: 500,
      }
    }
  },
  mounted() {
    this.showData()
    this.calculateTotalValues()
    //Font 12pt
    if(this.isElProveedor || ['ac296667317cfa35356801db4dc039b3'].includes(this.keyMaster)) {
      this.tableStyle.fontSize ='12pt';
    }
  },
  computed: {
    BillingNrc() {
      return addFormatNRC(this.dataProps.data.branch.BusinessBillingNRC);
    },
    BillingNit() {
      return addFormatToNIT(this.dataProps.data.branch.BusinessBillingNIT);
    },
    isBranchBilledInfo(){
      return this.dataProps.data.branch.BranchBilledInfo && 
              this.dataProps.data.branch.BranchBilledInfo != null && 
              this.dataProps.data.branch.BranchBilledInfo != '' && 
              this.dataProps.data.branch.BranchBilledInfo.trim().length > 0;
    },
    isElProveedor(){
          return ['27a3c7545503830ee33ce445986e7899', 'c9efbf453194b3947aa53fcfd0ed8d4c'].includes(this.keyMaster);
      },
  },
  watch: {
    "dataProps.show"() {},
  },
  methods: {
    stripHTML(html) {
      const div = document.createElement("div");
      div.innerHTML = html;
      return div.textContent || div.innerText || "";
    },
    async showData() {
      
        
          const partes = this.dataProps.data.header.InvoiceDate.split("/");
          const dia = partes[0];
          const mes = partes[1];
          const anio = partes[2];

          // Crear una nueva fecha en formato "yyyy-mm-dd"
          const fechaNueva = `${anio}-${mes}-${dia}`;
          const url =
            this.dataProps.data.branch.AuthFeMode == 1
              ? `https://admin.factura.gob.sv/consultaPublica?ambiente=01&codGen=${this.dataProps.data.header.CodigoGeneracion}&fechaEmi=${fechaNueva}`
              : `https://admin.factura.gob.sv/consultaPublica?ambiente=00&codGen=${this.dataProps.data.header.CodigoGeneracion}&fechaEmi=${fechaNueva}`;

          // Generar el código QR y mostrarlo en el elemento con id "qrcode"

          const opt = {
            errorCorrectionLevel: "H",
            type: "image/png",
            quality: 0.3,
            margin: 1,
            color: {
              dark: "#000000",
              light: "#ffffff",
            },
            width: 100,
          };

          QRCode.toDataURL(url, opt, (error, url) => {
            if (error) {
              console.log("Error al generar el código QR:", error);
              throw error;
            }

            this.urlQr = url;
          });
          await this.getImages();

      
    },
    numberWithCommas(x) {
      if(this.keyMaster === '55652726b965155654981d279f4900bf'){
        return formatNumber(x, 4)
      } 
      return formatNumber(x)
    },
    assignCuerpoDocumento() {
      this.dataProps.data.header.jsonMH.cuerpoDocumento =
        this.dataProps.data.body.map((item, index) => ({
          descripcion: item.ItemDescription,
          montoDescu: item.ItemDiscount,
          codigo: item.ID_Item,
          ventaGravada: item.ItemGravada,
          ivaItem: item.ItemIva,
          ventaNoSuj: item.ItemNoSuj,
          ventaExenta: item.ItemExenta,
          // "tributos": null,
          numItem: index + 1,
          noGravado: item.ItemNoGravada,
          psv: item.ItemPsv,
          // "tipoItem": 3,
          // "codTributo": null,
          uniMedida: item.ItemMeasureUnit,
          // "numeroDocumento": null,
          cantidad: item.ItemQuantity,
          precioUni: item.ItemUnitPrice,
        }));
    },
    async getImages() {
      try {
        const logo = this.dataProps.data.branch.BranchLogoPath;
        if (logo && logo !== 'null' && logo !== '') {
          // Usar el endpoint del backend que utiliza downloadFile de googleDriveDownload
          const response = await this.$API.utilities.downloadImageAsBase64({ imageUrl: logo });
          if (response && response.imageBase64) {
            this.dataProps.data.branch.BranchLogoPath = response.imageBase64;
          }
        }
      } catch (error) {
        console.error('Error al cargar la imagen:', error);
        // Mantener la URL original si hay error
      }
    },
    calculateTotalValues() {
      const invoicePayments = this.dataProps.data.invoicePayments || []
      const isHistoryFlow = invoicePayments.some((payment) => (
        Object.prototype.hasOwnProperty.call(payment, "DescriptionTypePayment") ||
        Object.prototype.hasOwnProperty.call(payment, "TotalPayment")
      ));
      const resolvePaymentCode = (payment) => {
        const code = payment?.typePayment
          ?? payment?.TypePayment
          ?? payment?.Codigo
          ?? payment?.codigo
          ?? payment?.code
          ?? payment?.Code;

        if (code !== undefined && code !== null && String(code).trim() !== "") {
          return String(code);
        }

        const description = String(
          payment?.descriptionPayment
          ?? payment?.DescriptionTypePayment
          ?? payment?.description
          ?? ""
        ).toLowerCase();

        return description.includes("billetes y monedas") ? "01" : "";
      };

      const resolvePaymentAmount = (payment) => {
        const value = payment?.totalPayment ?? payment?.TotalPayment ?? 0;
        const numericValue = Number(value);
        return Number.isFinite(numericValue) ? numericValue : 0;
      };

      const cashAmount = invoicePayments.reduce((sum, payment) => (
        resolvePaymentCode(payment) === "01"
          ? sum + resolvePaymentAmount(payment)
          : sum
      ), 0);

      const changeAmount = Number(this.dataProps.data.header.MoneyReturn || 0);
      this.change = parseFloat(changeAmount.toFixed(2));
      this.cash = parseFloat(
        (isHistoryFlow ? cashAmount + changeAmount : cashAmount).toFixed(2)
      );

      if (!invoicePayments.length && this.dataProps.data.header.InvoicePaymentType) {
        this.cash = parseFloat(
          Number(this.dataProps.data.header.InvoiceMontoTotalOperacion || 0).toFixed(2)
        );
      }
    }
    ,modifiedBranchBilledInfo() {
        const info = this.dataProps.data.branch.BranchBilledInfo
        if (this.isBranchBilledInfo) {
            return info
                .replace(/<p>/g, '')
                .replace(/<\/p>/g, '<br/>')
        }
        return null;
    },
  },
};
</script>

<style scoped>
.u-row .u-col-100 {
  width: 100% !important;
}
.btnclean {
  border-radius: 15px;
  border: 1px solid white;
  background-color: #f29d35 !important;
  color: white !important;
}
.btnclose {
  border-radius: 15px;
  border: 1px solid white;
  background-color: rgb(255, 38, 38) !important;
  color: white !important;
}

* {
  font-family: Arial, Helvetica, sans-serif !important;
  letter-spacing: 0.01px;
}
</style>
